<template>
  <div>
    <div class="row mt-2">
      <div class="col">
        <div class="row">
          <div class="col-md-4">
            <label for="from">From</label>
            <b-form-datepicker
              id="from"
              v-model="from"
              class="mb-2"
            ></b-form-datepicker>
          </div>
          <div class="col-md-4">
            <label for="to">To</label>
            <b-form-datepicker
              id="to"
              v-model="to"
              class="mb-2"
            ></b-form-datepicker>
          </div>
          <div class="col-md-4">
            <p class="font-weight-bold">Max 1 year range</p>
            <button @click="getStatement" class="btn btn-primary">
              Submit
            </button>
            <button @click="printStatement" class="btn btn-secondary ml-2">
              Print
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="isLoad==true">
      <div class="col text-center">
         <b-spinner label="Spinning" variant="primary"></b-spinner>
      </div>
    </div>

    <div class="row" v-if="isLoad==false">
      <div class="col">
        <table class="table table-sm table-bordered mt-3">
          <thead>
            <tr class="font-weight-bold bg-dark text-uppercase text-white font-size-11">
              <td>Date</td>
              <td>Detail</td>
              <td class="text-right">Debit</td>
              <td class="text-right">Credit</td>
              <td class="text-right">Balance</td>
            </tr>

            <tr v-for="item in items" :key="item.id">
              <td>
                {{
                  moment(new Date(item.created_at)).format("DD MMM YY, HH:mm")
                }}
              </td>

              <td>
                <span
                  v-if="
                    item.account_transaction.account_transactionable_type ==
                    'App\\Invoice'
                  "
                >
                  #{{
                    item.account_transaction.account_transactionable
                      .invoice_number
                  }}
                  - Invoice
                </span>
                <span
                  v-if="
                    item.account_transaction.account_transactionable_type ==
                    'App\\Payment'
                  "
                >
                  #{{
                    item.account_transaction.account_transactionable
                      .payment_number
                  }}
                  - Payment [{{
                    item.account_transaction.account_transactionable.reference
                  }}]
                </span>
                <span
                  v-if="
                    item.account_transaction.account_transactionable_type ==
                    'App\\AccountCredit'
                  "
                >
                  #{{
                    item.account_transaction.account_transactionable
                      .credit_number
                  }}
                  - Credit [{{
                    item.account_transaction.account_transactionable.reference
                  }}]
                </span>
                <span
                  v-if="
                    item.account_transaction.account_transactionable_type ==
                    'App\\AccountDebit'
                  "
                >
                  #{{
                    item.account_transaction.account_transactionable
                      .debit_number
                  }}
                  - Debit [{{
                    item.account_transaction.account_transactionable.reference
                  }}]
                </span>
              </td>
              <td class="text-right text-monospace">
                <span v-if="item.debit">{{ item.debit }}</span>
              </td>
              <td class="text-right text-monospace">
                <span v-if="item.credit">{{ item.credit }}</span>
              </td>
              <td class="font-weight-bold text-right text-monospace">{{ item.balance }}</td>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import partnerAccountRepo from "@/api/repos/partnerAccountRepo";

export default {
  props: ["accountId"],

  data() {
    return {
      items: [],
      from: this.moment().subtract(3, 'months').format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
      paymentShow: false,
      sidebarToggle: false,
      isLoad: false,
    };
  },
  mounted() {
    this.getStatement();
  },
  methods: {
    async getStatement() {

      //from is not greate
      if(this.moment(this.from).isAfter(this.moment(this.to))){
          this.$root.$bvToast.toast("From can not be after to", {
              title: "Invalid Range",
              autoHideDelay: 3000,
              variant: "danger",
            });
        return;
      }

      //not more then a year
       if(this.moment(this.to).diff(this.moment(this.from), 'days') > 366){
          this.$root.$bvToast.toast("Range can not be greater than 1 year", {
              title: "Invalid Range",
              autoHideDelay: 3000,
              variant: "danger",
            });
        return;
      }

      this.isLoad = true;
      try {
        let { data } = await partnerAccountRepo.accountStatement(
          this.accountId,
          this.from,
          this.to
        );

        this.items = data.running_balances;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    async printStatement() {

      //from is not greate
      if(this.moment(this.from).isAfter(this.moment(this.to))){
          this.$root.$bvToast.toast("From can not be after to", {
              title: "Invalid Range",
              autoHideDelay: 3000,
              variant: "danger",
            });
        return;
      }

      //not more then a year
       if(this.moment(this.to).diff(this.moment(this.from), 'days') > 366){
          this.$root.$bvToast.toast("Range can not be greater than 1 year", {
              title: "Invalid Range",
              autoHideDelay: 3000,
              variant: "danger",
            });
        return;
      }

      window.open(`/pdf/reports/account/${this.accountId}/partner-statement?from=${this.from}&to=${this.to}&cid=${localStorage.getItem('current_company_id')}`)
     
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
